import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-brand-select-dialog',
  templateUrl: './brand-select-dialog.component.html',
  styleUrls: ['./brand-select-dialog.component.scss'],
})
export class BrandSelectDialogComponent implements OnInit {
  @Input() makes;

  constructor() {
    console.log(this.makes);
  }

  ngOnInit() {}
}
